import type { ProductListItem } from 'types/capi/shared';

import {
  type ContractStockStatus,
  toContractStockStatus
} from '~/domain/stockStatus';

import InteractionEvent, {
  type InteractionTargetType
} from './InteractionEvent';

const NO_PRICE = -1;

export type ProductCardTargetProperties = {
  position?: number;
  price_currency: string;
  price_regular: number;
  price_sale?: number;
  product_id: string;
  retailer_id?: string;
  stock_status: ContractStockStatus;
};

type EventData = {
  gesture?: string;
  isBot: boolean;
  position?: number;
  product: ProductListItem;
  retailerId?: string;
};

class ProductCardInteractionEvent extends InteractionEvent<
  EventData,
  ProductCardTargetProperties
> {
  protected get targetType(): InteractionTargetType {
    return 'product_card';
  }

  protected getTargetProperties(): ProductCardTargetProperties {
    return {
      position: this.data.position,
      price_currency: this.data.product.price.currency,
      price_regular: this.data.product.price.regular ?? NO_PRICE,
      price_sale: this.data.product.price.sale ?? undefined,
      product_id: String(this.data.product.id),
      retailer_id: this.data.retailerId,
      stock_status: toContractStockStatus(this.data.product.stock_status)
    };
  }
}

export default ProductCardInteractionEvent;
